import { ChangeEvent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  LayerData,
  setLayerState,
} from '@rsos/reduxDataStore/src/features/layerOpacity/layerOpacitySlice';
import { AppState } from '../../../types/AppState';
import { StyledSlider } from './OpacitySlider.styles';

interface Props {
  layerId: string;
}

export const OpacitySlider = ({ layerId }: Props) => {
  const dispatch = useDispatch();

  const layers = useSelector((state: AppState) => state.layerOpacity.layers);

  const layerData: LayerData | undefined = layers[layerId];

  const value = layerData?.opacity ?? 40;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(
      setLayerState({
        layerId,
        layerData: {
          opacity: Number(event.target.value),
        },
      }),
    );
  };

  return <StyledSlider onChange={handleChange} value={value} />;
};
